"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeMoveOutDateModal = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var components_1 = require("../../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var copy_1 = require("../../../../copy");
var use_update_move_out_1 = require("../../../../data/use-update-move-out");
var utils_1 = require("../../../../utils");
var dateId = 'change-move-out-date';
function getErrorMessage(errors, id) {
    var error = errors.find(function (_a) {
        var errorId = _a.id;
        return errorId === id;
    });
    return error ? (react_1.default.createElement(react_1.default.Fragment, null,
        error.message,
        " ",
        error.inputOnlyAdditionalMessage)) : null;
}
var ChangeMoveOutDateModal = function (_a) {
    var _b, _c, _d;
    var onCancel = _a.onCancel, isOpen = _a.isOpen, accountId = _a.accountId, date = _a.date;
    var _e = (0, components_1.useComponents)(), SecondaryCTAButton = _e.SecondaryCTAButton, PrimaryCTAButton = _e.PrimaryCTAButton, ButtonGroup = _e.ButtonGroup, Stack = _e.Stack, Modal = _e.Modal;
    var _f = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _f.Copy, copy = _f.copy;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _g = __read((0, react_1.useState)(''), 2), moveOutError = _g[0], setMoveOutError = _g[1];
    var _h = __read((0, react_1.useState)([]), 2), errors = _h[0], setErrors = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), success = _j[0], setSuccess = _j[1];
    var _k = __read((0, react_1.useState)({
        day: '',
        month: '',
        year: '',
    }), 2), datepickerDate = _k[0], setDatepickerDate = _k[1];
    var now = (0, date_fns_1.startOfToday)();
    var minDate = (0, date_fns_1.addDays)(now, -28);
    var maxDate = (0, date_fns_1.addDays)(now, 28);
    var formattedFullDateNoYear = (0, utils_1.formatFullDateNoYear)(date);
    var _l = (0, use_update_move_out_1.useUpdateMoveOut)({ accountId: accountId }), loading = _l.loading, mutate = _l.mutate;
    var reset = function () {
        setMoveOutError('');
        setSuccess(false);
    };
    var confirmDateChange = function (event) {
        event.preventDefault();
        reset();
        if (loading) {
            return;
        }
        // Reset the errors.
        setErrors([]);
        var localErrors = [];
        // Do the date validation.
        if (!(0, utils_1.isValidDate)((0, utils_1.dateToString)(datepickerDate))) {
            localErrors.push({
                id: dateId,
                message: copy('dateError'),
            });
        }
        else {
            var chosenDate = (0, date_fns_1.parseISO)((0, utils_1.dateToString)(datepickerDate));
            if ((0, date_fns_1.isBefore)(chosenDate, minDate)) {
                localErrors.push({
                    id: dateId,
                    message: copy('minDateError', {
                        minDate: (0, date_fns_1.format)(minDate, 'do MMMM'),
                    }),
                    inputOnlyAdditionalMessage: react_1.default.createElement(Copy, { copyKey: "minDateInputOnlyError" }),
                });
            }
            else if ((0, date_fns_1.isAfter)(chosenDate, maxDate)) {
                localErrors.push({
                    id: dateId,
                    message: copy('maxDateError', {
                        maxDate: (0, date_fns_1.format)(maxDate, 'do MMMM'),
                    }),
                });
            }
        }
        if (localErrors.length) {
            setErrors(localErrors);
            return;
        }
        mutate({
            moveOutDate: (0, utils_1.dateToString)(datepickerDate),
        }, {
            onError: function (error) {
                return setMoveOutError(error.message || 'api error occured');
            },
            onCompleted: function () {
                var moveOutAccount = {
                    accountId: accountId,
                    moveOutDate: (0, utils_1.dateToString)(datepickerDate),
                    cancelled: false,
                };
                (0, utils_1.updateMoveOutAccounts)(moveOutAccount);
                setSuccess(true);
            },
        });
    };
    return (react_1.default.createElement(Modal, { "data-testid": "change-move-out-date-modal", title: moveOutError ? (react_1.default.createElement(Copy, { copyKey: "failureModalTitle" })) : success ? (react_1.default.createElement(Copy, { copyKey: "changeDateConfirmedTitle" })) : (react_1.default.createElement(Copy, { copyKey: "changeDateTitle" })), isDismissable: false, isOpen: isOpen }, moveOutError ? (react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
        react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_CHANGE_DATE_ERROR, properties: (_b = {},
                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                _b.error = moveOutError,
                _b) },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Copy, { copyKey: "failureModalBody" }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(PrimaryCTAButton, { onClick: function () {
                    reset();
                    onCancel();
                } },
                react_1.default.createElement(Copy, { copyKey: "changeDateCloseCTA" }))))) : success ? (react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
        react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_CHANGE_DATE_SUCCESS, properties: (_c = {},
                _c[core_1.INTERNAL_EVENT_FLAG] = true,
                _c) },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Copy, { copyKey: "changeDateConfirmedBody", values: {
                        moveOutDate: (0, utils_1.formatFullDateNoYear)((0, utils_1.dateToString)(datepickerDate)),
                    } }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(PrimaryCTAButton, { onClick: function () {
                    reset();
                    onCancel();
                    navigate({
                        search: "?date=".concat((0, utils_1.dateToString)(datepickerDate)),
                    }, { replace: true });
                } },
                react_1.default.createElement(Copy, { copyKey: "changeDateCloseCTA" }))))) : (react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Copy, { copyKey: "changeDateText", values: {
                    date: formattedFullDateNoYear,
                } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(components_1.DatepickerField, { id: dateId, label: copy('formDateLabel'), hint: copy('formDatepickerHint'), error: getErrorMessage(errors, dateId), onChange: function (date) {
                    var _a = __read(date.trim().split('/'), 3), day = _a[0], month = _a[1], year = _a[2];
                    setDatepickerDate({
                        day: day,
                        month: month,
                        year: year,
                    });
                }, isDateUnavailable: function (datepickerDate) {
                    return (0, date_fns_1.isBefore)(datepickerDate.toString(), minDate) ||
                        (0, date_fns_1.isAfter)(datepickerDate.toString(), maxDate);
                } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("form", { onSubmit: confirmDateChange, method: "PUT", noValidate: true },
                react_1.default.createElement(ButtonGroup, null,
                    react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_DATE_SUBMIT, properties: (_d = {},
                            _d[core_1.INTERNAL_EVENT_FLAG] = true,
                            _d.date = (0, utils_1.dateToString)(datepickerDate),
                            _d) },
                        react_1.default.createElement(PrimaryCTAButton, { "data-testid": "change-date-button" },
                            react_1.default.createElement(Copy, { copyKey: "changeDate" }))),
                    react_1.default.createElement(SecondaryCTAButton, { onClick: function () {
                            setErrors([]);
                            onCancel();
                        } },
                        react_1.default.createElement(Copy, { copyKey: "formCancelButtonText" })))))))));
};
exports.ChangeMoveOutDateModal = ChangeMoveOutDateModal;
